import addDays from 'date-fns/addDays';
import endOfWeek from 'date-fns/endOfWeek';
import startOfDay from 'date-fns/startOfDay';
import startOfWeek from 'date-fns/startOfWeek';
import subDays from 'date-fns/subDays';

export const getThisWeekEndIsoString = (date: Date) => {
	/*
	 * Calculate the end of the week for the current date, with the week starting on Monday (weekStartsOn: 1).
	 * Add one day to the end of the week to get the start of the next day.
	 * Set the time to the start of the day for the calculated date
	 */

	const thisWeekEnd = startOfDay(addDays(endOfWeek(date, { weekStartsOn: 1 }), 1));
	return thisWeekEnd.toISOString();
};

export const getThisWeekStartIsoString = (date: Date) => {
	/*
	 * Calculate the start of the week for the current date, with the week starting on Monday (weekStartsOn: 1).
	 * Set the time to the start of the day for the calculated date
	 */

	const thisWeekStart = startOfDay(startOfWeek(date, { weekStartsOn: 1 }));
	return thisWeekStart.toISOString();
};

export const getThirtyDaysAgoIsoString = (date: Date) => {
	// Subtract 30 days from the current date, get the start of the day
	const startOfThirtyDaysAgo = startOfDay(subDays(date, 30));
	return startOfThirtyDaysAgo.toISOString();
};
